import React, { FC } from "react";
import { Location, NavigateFunction } from "react-router-dom";
import { ItemsStore } from "../store";
import {
  DashboardSidebar,
  SidebarBody,
  SidebarHeader,
  SidebarLabels,
} from "../styles";
import {
  AuthService,
  CustomLabel,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { ItemSideBarModel } from "../models";
import { observer } from "mobx-react";
import { getMerchantAccountStore } from "../../modules/merchantAccounts/MerchantAccountStore";

type Props = {
  navigate: NavigateFunction;
  location: Location;
  itemStore: ItemsStore;
};

const ItemSideBar: FC<Props> = ({ location, itemStore, navigate }) => {
  const [isCollapsed, toggleCollapse] = React.useState(false);
  const merchantAccountStore = getMerchantAccountStore();

  // The sidebar renders on routes that have no merchant account switcher, so
  // make sure the gateway is known before deciding which nav items to show.
  React.useEffect(() => {
    if (
      !merchantAccountStore.merchantAccounts.length &&
      !merchantAccountStore.isMerchantAccountsLoadingInProgress
    ) {
      merchantAccountStore.fetchMerchantAccounts();
    }
  }, [merchantAccountStore]);

  function goToRoute(route: string) {
    if (!route) return;

    itemStore.updateSearchValue("");
    navigate(AuthService.prefixRoute + route);
    // switch (route) {
    //     case 'merchant-accounts':
    //     case 'subscriptions':
    //     case 'payments':
    //     case 'invoices':
    //     case 'contacts':
    //     case 'activity':
    //         this.props.navigate('/app/' + route);
    //         break;
    //     default:
    //         this.props.navigate('/app/items/' + route);
    //         break;
    // }
  }

  function sideBarData() {
    return ItemSideBarModel.getSideBarData(location, {
      isNMIGatewayAccount: merchantAccountStore.isNMIGatewayAccount,
    });
  }

  return (
    <>
      <DashboardSidebar
        // Uncomment below 2 lines, if require collapsibility
        isCollapsed={isCollapsed}
        className={isCollapsed ? "collapsed-styles" : ""}
      >
        <div>
          <SidebarHeader
            className={`sidebar-header ${isCollapsed ? "collapsed-center" : ""}`}
            onClick={() => toggleCollapse(!isCollapsed)}
          >
            <CustomLabel>Menu</CustomLabel>
            <div>
              <i
                className={`fa fa-light ${
                  isCollapsed ? " fa-chevron-right" : " fa-chevron-left"
                } clickable`}
              ></i>
              {/* <i className="fa fa-solid fa-chevron-right"></i> */}
            </div>
          </SidebarHeader>
        </div>
        <SidebarBody
          className="sidebar-body"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {sideBarData().map((item, idx) => {
            const className = item.isActive() ? "active" : "";
            return (
              <SidebarLabels
                className={`${className} ${item.className || ""} ${isCollapsed ? "collapsed-center" : ""}`}
                key={idx}
                onClick={(e) => {
                  e.stopPropagation();

                  if (item.className === "disabled") return;
                  goToRoute(item.route || "");
                }}
              >
                <img src={item.isActive() ? item.activeIcon : item.icon} />
                <CustomLabel>{item.title}</CustomLabel>
              </SidebarLabels>
            );
          })}
        </SidebarBody>
      </DashboardSidebar>
    </>
  );
};

export default withRouter(observer(ItemSideBar));
